<template>
  <div>
    <!-- <div class="field-row">
        <input type="text" v-model="title" name="" id="" placeholder="Category name" />
    </div>
    <div class="field-row">
        <Textarea v-model="description" placeholder="description"></Textarea>
    </div>
    <div class="field-row">
        <button @click.prevent="savedata">Save</button>
    </div> -->
    <a-modal v-model="visible" title="Update Request" onOk="handleOk" :width="this.settings['isMobileView'] ? 480 : this.settings['isTabletView'] ? 720 : 720" style="top: 20px;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleConfirmEdit">Update</a-button>
      </template>
      <a-spin :spinning="spinning">
        <div class="row">
          <div class="col-12" v-if="oldrecord.created_by !== undefined">
            <h4>REQUEST ID: {{oldrecord.request_id}}</h4>
            <p class="mb-2">
              Raised by: <span class="font-weight-bold">{{ oldrecord.created_by.first_name }} {{ oldrecord.created_by.last_name }}</span> | Created on: <span class="font-weight-bold">{{moment(oldrecord.created_at).format('DD-MMM-YYYY h:mm A')}}</span>
            </p>
          </div>
        </div>
        <hr>
        <a-form class="mb-4" :form="form">
          <a-form-item label="Subject ">
              <a-textarea
                  placeholder="Subject"
                  v-decorator="['subject',]"
                  :disabled="true"
                  style="color: #000000"
              />
          </a-form-item>
          <a-form-item label="Description">
              <a-textarea placeholder="Description" style="color: #000000" :disabled="true" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 500, message: 'Must not exceed 100 characters!'}]}]" />
          </a-form-item>
          <div class="row">
            <div class="col-md-6 mb-2">
              <a-form-item label="Select status">
                <a-select placeholder="Select status" :initialValue="oldrecord.status" v-decorator="['status', { rules: [{ required: true, message: 'Please select a status!'}]}]">
                  <a-select-option v-for="(cat, index) in statuses" :key="index" :value="cat">{{cat}}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2">
              <a-form-item label="Select priority">
                <a-select placeholder="Select priority" :initialValue="oldrecord.priority" v-decorator="['priority', { rules: [{ required: true, message: 'Please select a priority!'}]}]">
                  <a-select-option v-for="(priority, index) in priorities" :key="index" :value="priority">{{priority}}</a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-2">
              <a-form-item label="Assigned to" class="mb-2">
                <a-select show-search size="default" v-model="selectedAssignedTo" placeholder="Search Staff.."
                          optionFilterProp="children" style="width: 100%" @change="handleStaffChange" @search="searchStaffs"
                          :filterOption="true" :initialValue="oldrecord.assigned_to.id">
                  <template v-for="staff in staffs">
                    <a-select-option :value="staff.id" :key="staff.id">
                      {{ staff.first_name }} {{ staff.last_name }} ({{ staff.staff_id }})
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-2">
              <strong>Attachments ({{supportRequesFiles.length}}): </strong>
              <div v-for="(supportReqFile, index) in supportRequesFiles" :key="index"  >
                <a :href="supportReqFile.file" target="_blank"><span class="fa fa-download"></span> {{supportReqFile.file.split('/').pop()}}</a>
              </div>
            </div>
          </div>
          <support-request-replies :dataFromParent="replies"></support-request-replies>
          <a-form-item>
            <a-textarea
              placeholder="Reply text...."
              v-decorator="['reply',]"
            />
          </a-form-item>
          <a-form-item>
            <a-upload v-decorator="['file', { rules: [{ required: false, message: 'Please input homework file.' }] }]"
                      accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :fileList="fileList" :multiple="true" :remove="handleRemove" :beforeUpload="beforeUpload"
                      :disabled="uploadDisabled">
              <button type="button" class="btn btn-dark btn-with-addon">
                <span class="btn-addon">
                  <i class="btn-addon-icon fe fe-file-text" />
                </span>
                Attach File
              </button>
            </a-upload>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>

import moment from 'moment'
import { mapState } from 'vuex'
import SupportRequestReplies from './replies'

export default {
  name: 'EditSupportRequest',
  components: { SupportRequestReplies },
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      spinning: false,
      oldrecord: {},
      newrecord: {},
      statuses: [],
      priorities: [],
      supportRequestWithReplies: null,
      replies: null,
      supportRequesFiles: [],
      fileList: [],
      uploadDisabled: false,
      selectedAssignedTo: null,
      staffSearch: null,
      staffCurrent: 1,
      staffPageSize: 10,
      staffSpinning: false,
      staffs: [],
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  mounted: function () {
    this.statuses = {
      'Open': 'Open',
      'In Progress': 'In Progress',
      'Resolved': 'Resolved',
      'Closed': 'Closed',
      'Escalated': 'Escalated',
      'On hold': 'On hold',
    }

    this.priorities = {
      'Low': 'Low',
      'Medium': 'Medium',
      'High': 'High',
      'Urgent': 'Urgent',
    }
    this.$eventBus.$on('openEditSupportRequestForm', this.showForm)
  },
  methods: {
    moment,
    showForm: function(record) {
      console.log('recordNesss', record.subject)
      this.visible = true
      // console.log('passed record', record)
      this.oldrecord = record
      this.spinning = true
      this.staffSearch = this.oldrecord.assigned_to.first_name
      this.getStaffs(this.oldrecord.assigned_to.first_name)

      this.staffs = []
      this.staffs = this.staffs.push(this.oldrecord.assigned_to)
      this.selectedAssignedTo = this.oldrecord.assigned_to.id
      this.getSingleSupportRequestWithReplies(record.id)
    },
    getStaffs: function(isSearch) {
      this.staffSpinning = true

      let page = this.staffCurrent
      if (isSearch) {
        page = 1
        this.staffCurrent = 1
      }
      this.$http.get('/api/staff', {
        params: {
          limit: this.staffPageSize,
          search: this.staffSearch,
          page: page,
        },
      }).then(({ data }) => {
        this.staffs = data.data
        this.staffSpinning = false
        this.staffsMeta = data.meta
      })
    },
    searchStaffs: function(value) {
      if (value) {
        this.staffSearch = value
        this.getStaffs(true)
      }
    },
    handleChange(info) {
      let fileList = [...info.fileList]

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      // fileList = fileList.slice(-2)

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url
        }
        return file
      })
      this.fileList = fileList
    },

    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isPDF = file.type === 'application/pdf'
      const isMsExcel =
        file.type === 'application/vnd.ms-excel' ||
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isMsWordDoc =
        file.type === 'application/msword' ||
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      if (!(isJPG || isPNG || isPDF || isMsExcel || isMsWordDoc)) {
        this.$message.error(
          'You can upload only JPG, PNG, Excel, MS Word or PDF file!'
        )
        this.handleRemove(file)
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('File must smaller than 5MB!')
        this.handleRemove(file)
      }
      // return isJPG && isLt2M
      // this.uploadDisabled = true
      return false
    },
    handleStaffChange: function (value) {
      if (value) {
        this.selectedAssignedTo = value
      }
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleConfirmEdit() {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will update the new data.`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.handleEdit()
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    getSingleSupportRequestWithReplies(supportRequestId) {
      this.$http
        .get(`/api/support_request/${supportRequestId}/replies`)
        .then((resp) => {
          if (resp.status === 200) {
            this.loading = false
            this.spinning = false
            let data = resp.data.data
            console.log(data)
            this.supportRequestWithReplies = data
            this.replies = this.supportRequestWithReplies.replies
            this.supportRequesFiles = this.supportRequestWithReplies.files
            this.form.setFieldsValue({
              subject: data.subject,
              description: data.description,
              status: data.status,
              priority: data.priority,
            })
          } else {
            this.$notification['warning']({
              message: 'Unknown Error',
              description: 'There appears to be an error while submitting data.',
            })
          }
        })
        .catch(error => {
          this.$neoNotify.error(error)
        })
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('old data', this.oldrecord)
          console.log('formdata', values)
          console.log(this.fileList,)
          const formBody = {
            status: values.status,
            priority: values.priority,
            assigned_to: this.selectedAssignedTo,
            reply: values.reply,
            files: this.fileList,
            _method: 'PATCH',
          }
          let formData = window.jsonToFormData(formBody)
          this.$http
            .post(`/api/support_request/${this.oldrecord.id}`, formData)
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEditedSupportRequest')
                this.form.resetFields()
                this.fileList = []
                this.$notification['success']({
                  message: 'Successfully updated',
                  description: 'Request updated successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>

<style>

</style>
